import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    Box,
    Container,
    Typography,
    Divider,
    TextField,
    Autocomplete,
    Chip,
    InputAdornment,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    IconButton,
} from "@mui/material";

import queryGraphql from "../../../helpers/ApiInterface";
import { ExpandMore } from "@mui/icons-material";
import MainDrawer from "../../MainDrawer";
import DataLakesRequestsTable from "../DataLakes/DataLakesRequestsTable"; // Changed import
import MiniBot from "../../MiniBot";

interface SearchOptions {
    chipLabel: string;
    dropdownLabel: string;
    category: string;
    groupBy: string;
}

let searchOptions: SearchOptions[] = [];

const DataLakesRequestsPage: React.FC = () => { // Changed component name
    const [dataLakes, setDataLakes] = useState<any[]>([]); // State variable for Data Lake data
    const [searchQuery, setSearchQuery] = useState<SearchOptions[]>([]);
    const [updates, setUpdates] =  useState<any[]>([]);
    const navigate = useNavigate();

    React.useEffect(() =>{
        const fetchData = async () => {
            try {
                const data = await queryGraphql(`
                        query Query {
                        resourceStatuses {
                            id
                            currentStatus
                            resourceId
                        }
                        }
                    `);
                if(data.resourceStatuses){
                    setUpdates(data.resourceStatuses);
                }
                }
                catch(e){
            console.log(e);
                }
    }
    fetchData();
    },[]);  
    
    React.useEffect(() => {
        const fetchData = async () => {
            try {
                // Using the getDataplexLakes query
                const data = await queryGraphql(`
                    query GetDataplexLakes { # Changed query name
                      getDataplexLakes { # Changed field name
                        id
                        name
                        solutionType
                        cloudProvider
                        costLabelPairs {
                          cost
                          label
                        }
                        status
                        details {
                          dataplexLake { # Changed from dataSources
                            projectId
                            location
                            description
                          }
                        }
                        reasonForRejection
                        createdAt
                        updatedAt
                        solutionOwner {
                          id
                          name
                          email
                          googleProfilePicture
                        }
                        solutionApprover {
                          id
                          name
                          email
                          googleProfilePicture
                        }
                      }
                    }
                `);

                const rawDataLakesData = data.data?.getDataplexLakes || data.getDataplexLakes || []; // Changed field name

                let dataLakesArr = rawDataLakesData.map((e: any) => {
                    return {
                        id: e.id,
                        lakeName: e.name, // Changed from dataSourceName
                        status: e.status ? e.status.toLowerCase() : 'pending',
                        createdAt: e.createdAt ? new Date(Number(e.createdAt)).toISOString() : null,
                        actionedAt: e.updatedAt ? new Date(Number(e.updatedAt)).toISOString() : null,
                        
                        lakeOwnerName: e.solutionOwner?.name, // Changed from dataSourceOwnerName
                        lakeOwnerAvatar: e.solutionOwner?.googleProfilePicture, // Changed from dataSourceOwnerAvatar
                        
                        lakeApproverName: e.solutionApprover?.name, // Changed from dataSourceApproverName
                        lakeApproverAvatar: e.solutionApprover?.googleProfilePicture, // Changed from dataSourceApproverAvatar

                        // Changed from resourceSpecType to solutionCategoryType (or similar, if needed)
                        // For lakes, the "type" is dataplexLake, so resourceSpecType might not be as relevant here.
                        // I'll use solutionCategoryType for now, as it's directly available.
                        solutionCategoryType: e.solutionCategoryType, 
                        cloudProvider: e.cloudProvider,
                        projectId: e.details?.dataplexLake?.projectId, // Changed from dataSources

                        reasonForRejection: e.reasonForRejection,
                    };
                });
                setDataLakes(dataLakesArr);

                searchOptions = dataLakesArr
                    .map((e: any) => {
                        const options = [
                            {
                                category: "lakeName", // Changed
                                groupBy: "DATA LAKE NAME", // Changed
                                chipLabel: `Lake Name: ${e.lakeName}`, // Changed
                                dropdownLabel: e.lakeName, // Changed
                            },
                            {
                                category: "lakeOwnerName", // Changed
                                groupBy: "OWNER",
                                chipLabel: `Owner: ${e.lakeOwnerName}`, // Changed
                                dropdownLabel: e.lakeOwnerName, // Changed
                            },
                            {
                                category: "lakeApproverName", // Changed
                                groupBy: "APPROVER",
                                chipLabel: `Approver: ${e.lakeApproverName}`, // Changed
                                dropdownLabel: e.lakeApproverName, // Changed
                            },
                        ];
                        
                        if (e.solutionCategoryType) { // Changed from resourceSpecType
                            options.push({
                               category: "solutionCategoryType", // Changed
                               groupBy: "CATEGORY TYPE", // Changed
                               chipLabel: `Type: ${e.solutionCategoryType}`, // Changed
                               dropdownLabel: e.solutionCategoryType, // Changed
                           });
                       }
                       if (e.cloudProvider) {
                        options.push({
                           category: "cloudProvider",
                           groupBy: "CLOUD PROVIDER",
                           chipLabel: `Provider: ${e.cloudProvider}`,
                           dropdownLabel: e.cloudProvider,
                       });
                   }
                        if (e.status) {
                            options.push({
                                category: "status",
                                groupBy: "STATUS",
                                chipLabel: `Status: ${e.status.charAt(0).toUpperCase() + e.status.slice(1)}`,
                                dropdownLabel: e.status.charAt(0).toUpperCase() + e.status.slice(1),
                            });
                        }
                        return options;
                    })
                    .flat();

                searchOptions = searchOptions.filter(
                    (obj, index, self) =>
                        obj.dropdownLabel &&
                        index ===
                        self.findIndex(
                            (t) => t.category === obj.category && t.dropdownLabel === obj.dropdownLabel
                        )
                );
                searchOptions.sort((a, b) => {
                    if (a.groupBy > b.groupBy) return 1;
                    if (a.groupBy < b.groupBy) return -1;
                    if (a.dropdownLabel > b.dropdownLabel) return 1;
                    if (a.dropdownLabel < b.dropdownLabel) return -1;
                    return 0;
                });

            } catch (error) {
                console.log(error);
            }
        };

        fetchData();
    }, []);

    const filteredDataLakes = // Changed variable name
        searchQuery.length === 0
            ? dataLakes
            : dataLakes.filter(
                    (dataLake: any) => // Changed variable name
                        (searchQuery.filter((e) => e.category === "lakeName").length > 0 // Changed category
                            ? searchQuery.filter((e) => e.category === "lakeName").map((e) => e.dropdownLabel?.toLowerCase()).includes(dataLake.lakeName?.toLowerCase()) // Changed field
                            : true) &&
                        (searchQuery.filter((e) => e.category === "lakeOwnerName").length > 0 // Changed category
                            ? searchQuery.filter((e) => e.category === "lakeOwnerName").map((e) => e.dropdownLabel?.toLowerCase()).includes(dataLake.lakeOwnerName?.toLowerCase()) // Changed field
                            : true) &&
                         (searchQuery.filter((e) => e.category === "lakeApproverName").length > 0 // Changed category
                            ? searchQuery.filter((e) => e.category === "lakeApproverName").map((e) => e.dropdownLabel?.toLowerCase()).includes(dataLake.lakeApproverName?.toLowerCase()) // Changed field
                            : true) &&
                        (searchQuery.filter((e) => e.category === "solutionCategoryType").length > 0 // Changed category
                            ? searchQuery.filter((e) => e.category === "solutionCategoryType").map((e) => e.dropdownLabel?.toLowerCase()).includes(dataLake.solutionCategoryType?.toLowerCase()) // Changed field
                            : true) &&
                        (searchQuery.filter((e) => e.category === "cloudProvider").length > 0
                            ? searchQuery.filter((e) => e.category === "cloudProvider").map((e) => e.dropdownLabel?.toLowerCase()).includes(dataLake.cloudProvider?.toLowerCase())
                            : true) &&
                        (searchQuery.filter((e) => e.category === "status").length > 0
                            ? searchQuery.filter((e) => e.category === "status").map((e) => e.dropdownLabel?.toLowerCase()).includes(dataLake.status?.toLowerCase())
                            : true)
              );
    
    const filteredActiveDataLakes = filteredDataLakes.filter( // Changed variable name
        (p: any) => p.status === "active" || p.status === "approved"
    );
    const filteredPendingDataLakes = filteredDataLakes.filter( // Changed variable name
        (p: any) => p.status === "pending"
    );
    const filteredRejectedDataLakes = filteredDataLakes.filter( // Changed variable name
        (p: any) => p.status === "rejected"
    );

    return (
        <Box sx={{ display: "flex" }}>
            <MainDrawer index={"requests-data-lakes"} /> {/* Changed index */}
            <MiniBot/>
            <Box
                component="main"
                sx={{
                    flex: 1,
                    bgcolor: "#fafafa",
                    minHeight: window.innerHeight,
                }}
            >
                <Container maxWidth={false} disableGutters>
                    <Box bgcolor="#FFFFFF" p={2} mb="18px">
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                marginY: 1,
                                marginLeft: 2,
                            }}
                        >
                            <Typography fontSize="22px" gutterBottom fontFamily="Gilroy-Bold">
                                Requests
                            </Typography>
                            <IconButton
                                aria-label="Help" 
                                onClick={()=> window.open(`${process.env.REACT_APP_HOST_DOMAIN}/docs` , "_blank")}
                                sx={{ padding: 0, border: 'none', mr:2, '&:hover': { backgroundColor: 'action.hover' } }}
                              >
                                <Box component="img" src="/assets/Help.svg" alt="" sx={{ width: 40,  height: 40, display: 'block' }} />
                              </IconButton>
                        </Box>
                        <Divider sx={{ marginY: 1 }} />
                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mx: 2 }}>
                            <Box>
                                <Typography fontFamily="Gilroy-SemiBold" fontSize="16px">
                                    {`DATA LAKES (${dataLakes.length})`} {/* Changed text */}
                                </Typography>
                                <Typography fontFamily="Gilroy-Regular" fontSize="14px">
                                    {`View all the requests raised for Data Lakes`} {/* Changed text */}
                                </Typography>
                            </Box>
                            <Autocomplete
                                multiple
                                options={searchOptions}
                                filterSelectedOptions
                                getOptionLabel={(option) => option.dropdownLabel}
                                defaultValue={[]}
                                groupBy={(option) => option.groupBy}
                                renderTags={(tagValue, getTagProps) => {
                                    return tagValue.map((option, index) => (
                                        <Chip {...getTagProps({ index })} size="small" label={option.chipLabel} />
                                    ));
                                }}
                                onChange={(e, newVal, reason) => {
                                    setSearchQuery(newVal);
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="filled"
                                        placeholder="Search by lake name, owner, status etc" 
                                        fullWidth
                                        size="small"
                                        hiddenLabel
                                        InputProps={{
                                            ...params.InputProps,
                                            startAdornment: (
                                                <>
                                                    <InputAdornment position="start">
                                                        <img src="/assets/search-normal.svg" alt="Filter Icon" style={{ width: "16px", paddingLeft: "4px" }}/>
                                                    </InputAdornment>
                                                    {params.InputProps.startAdornment}
                                                </>
                                            ),
                                            disableUnderline: true,
                                            style: { backgroundColor: "#f4f4f4", minHeight: "45px", width: "500px", borderRadius: "8px", fontFamily: "Gilroy-Regular", fontSize: "14px" },
                                        }}
                                    />
                                )}
                            />
                        </Box>
                    </Box>
                    <Box m={2}>
                        <Accordion
                            defaultExpanded={filteredPendingDataLakes.length > 0 ? true : false} // Changed variable name
                            elevation={0}
                            sx={{ borderRadius: "8px", mb: "16px", "&:before": { display: "none" }, bgcolor: "#fafafa" }}
                            disabled={filteredPendingDataLakes.length === 0} // Changed variable name
                        >
                            <AccordionSummary expandIcon={<ExpandMore />}>
                                <Box sx={{ display: "flex", alignItems: "center" }}>
                                    <img src="/assets/clock.svg" alt="Pending Icon" style={{ width: "20px", marginRight: "8px" }} />
                                    <Typography fontSize="16px" fontFamily="Gilroy-SemiBold">
                                        Pending Data Lakes ({filteredPendingDataLakes.length}) {/* Changed text */}
                                    </Typography>
                                </Box>
                            </AccordionSummary>
                            <AccordionDetails>
                                {filteredPendingDataLakes.length > 0 && ( // Changed variable name
                                    <DataLakesRequestsTable dataLakes={filteredPendingDataLakes} resourceStatuses={updates}/> 
                                )}
                            </AccordionDetails>
                        </Accordion>
                        <Accordion
                            defaultExpanded={true}
                            elevation={0}
                            sx={{ borderRadius: "8px", mb: "16px", "&:before": { display: "none" }, bgcolor: "#fafafa" }}
                            disabled={filteredActiveDataLakes.length === 0} // Changed variable name
                        >
                            <AccordionSummary expandIcon={<ExpandMore />}>
                                <Box sx={{ display: "flex", alignItems: "center" }}>
                                    <img src="/assets/tickcircle.svg" alt="Active Icon" style={{ width: "20px", marginRight: "8px" }}/>
                                    <Typography fontSize="16px" fontFamily="Gilroy-SemiBold">
                                        Active Data Lakes ({filteredActiveDataLakes.length}) {/* Changed text */}
                                    </Typography>
                                </Box>
                            </AccordionSummary>
                            <AccordionDetails>
                                {filteredActiveDataLakes.length > 0 && ( // Changed variable name
                                    <DataLakesRequestsTable dataLakes={filteredActiveDataLakes} resourceStatuses={updates}/> 
                                )}
                            </AccordionDetails>
                        </Accordion>

                        <Accordion
                            defaultExpanded={filteredRejectedDataLakes.length > 0 ? true : false} // Changed variable name
                            elevation={0}
                            sx={{ borderRadius: "8px", "&:before": { display: "none" }, bgcolor: "#fafafa" }}
                            disabled={filteredRejectedDataLakes.length === 0} // Changed variable name
                        >
                            <AccordionSummary expandIcon={<ExpandMore />}>
                                <Box sx={{ display: "flex", alignItems: "center" }}>
                                    <img src="/assets/reject.svg" alt="Rejected Icon" style={{ width: "20px", marginRight: "8px" }} />
                                    <Typography fontSize="16px" fontFamily="Gilroy-SemiBold">
                                        Rejected Data Lakes ({filteredRejectedDataLakes.length}) {/* Changed text */}
                                    </Typography>
                                </Box>
                            </AccordionSummary>
                            <AccordionDetails>
                                {filteredRejectedDataLakes.length > 0 && ( // Changed variable name
                                    <DataLakesRequestsTable dataLakes={filteredRejectedDataLakes} resourceStatuses={updates}/> 
                                )}
                            </AccordionDetails>
                        </Accordion>
                    </Box>
                </Container>
            </Box>
        </Box>
    );
};

export default DataLakesRequestsPage;